<template>
  <div id="layout-container">
    <nav-header/>
    <nav-module :menus="menus" @setModule="setModule"/>
    <nav-menu :menus="menus" @setMenu="setMenu"/>
    <div id="work-container">
      <transition name="fade-transform" mode="out-in">
        <router-view/>
      </transition>
    </div>
    <div id="footer-container">{{config.systemCompany}}</div>
    <div id="p1"></div>
    <div id="p2"></div>
    <div id="p3"></div>
    <div id="p4"></div>
    <div id="mtree">
      <el-tree
        ref="tree"
        node-key="id"
        empty-text=""
        :props="props"
        :data="data"
        :expand-on-click-node="false"
        default-expand-all
        highlight-current
        @node-click="clickNode">
            <span slot-scope="{ node, data }">
              <i :class="data.icon || 'iconmenu el-icon-menu-default'"></i> {{ node.label }}
            </span>
      </el-tree>
    </div>
  </div>
</template>
<style lang="less">
  @import "../style/layout.less";
</style>
<script>
  import async from 'async'
  import NavHeader from '../component/layout/NavHeader'
  import NavModule from '../component/layout/NavModule'
  import NavMenu from '../component/layout/NavMenu'
  import * as layout from '../core/layout'
  import * as config from '../core/config'
  import * as configApi from '../api/config'
  import * as selfApi from '../api/self'

  export default {
    name: 'Layout',
    components: {
      'nav-header': NavHeader,
      'nav-module': NavModule,
      'nav-menu': NavMenu
    },
    data () {
      return {
        config: config,
        menus: [],
        props: {label: 'name'},
        data: []
      }
    },
    computed: {
      thumb: function () {
        return this.$store.state.session.thumb
      }
    },
    watch: {
      thumb: {
        immediate: true,
        handler (nv) {
          this.$nextTick(function () {
            layout.setLayout()
          })
        }
      }
    },
    mounted () {
      async.auto({
        fn1: (callback) => {
          selfApi.get(null).then(rr => {
            if (rr.data.officer_id === 'none') {
              callback(rr, null)
            } else {
              callback(null, rr)
            }
          }).catch(rr => {
            callback(rr, null)
          })
        },
        fn2: ['fn1', (rets, callback) => {
          selfApi.listOfficer(null).then(rr => {
            callback(null, rr)
          }).catch(rr => {
            callback(rr, null)
          })
        }],
        fn3: ['fn1', (rets, callback) => {
          selfApi.listMenu(null).then(rr => {
            callback(null, rr)
          }).catch(rr => {
            callback(rr, null)
          })
        }],
        fn4: ['fn1', (rets, callback) => {
          selfApi.listControl(null).then(rr => {
            callback(null, rr)
          }).catch(rr => {
            callback(rr, null)
          })
        }],
        fn5: ['fn1', (rets, callback) => {
          configApi.get(null).then(rr => {
            callback(null, rr)
          }).catch(rr => {
            callback(rr, null)
          })
        }]
      }, (err, rets) => {
        if (err) {
          if (err.data && err.data.officer_id === 'none') {
            this.$alert('请找管理员分配所属岗位', {
              showClose: false,
              showConfirmButton: false,
              center: true
            })
          } else {
            this.$base.failure(this, '数据加载错误，请刷新页面重新加载')
          }
          return
        }
        this.$store.dispatch('setSessionThumb', config.thumb)
        this.$store.dispatch('setSelfInfo', rets.fn1.data)
        this.$store.dispatch('setSelfOfficerList', rets.fn2.data)
        this.$store.dispatch('setSessionMenuList', rets.fn3.data)
        this.$store.dispatch('setSessionControlList', rets.fn4.data)
        this.$store.dispatch('setSessionDictMap', rets.fn5.data)
        // 根据运行环境获取菜单资源和字典项数据
        if (config.mode === 'local') {
          // fetchLocalData：本地菜单资源和字典项、fetchServerData：服务器菜单资源
          layout.fetchLocalData().then(menus => {
            // 校验store中的变量是否在layout刷新前被设置了，如果被设置了，在重新加载布局后该变量是否在此布局列表中，如果在则有效，不在则重置为初始值
            if (this.$store.state.session.module && this.$store.state.session.module.id) {
              let find = false
              for (let item of menus) {
                if (config.layout === 1 && item.pid === '-1' && item.id === this.$store.state.session.module.id) {
                  find = true
                  break
                }
              }
              if (!find) {
                this.$store.dispatch('setSessionModule', {})
              }
            } else {
              this.$store.dispatch('setSessionModule', {})
            }
            this.menus = menus
          })
        } else {
          // fetchLocalData：本地菜单资源和字典项、fetchServerData：服务器菜单资源
          layout.fetchServerData().then(menus => {
            // 校验store中的变量是否在layout刷新前被设置了，如果被设置了，在重新加载布局后该变量是否在此布局列表中，如果在则有效，不在则重置为初始值
            if (this.$store.state.session.module && this.$store.state.session.module.id) {
              let find = false
              for (let item of menus) {
                if (config.layout === 1 && item.pid === '-1' && item.id === this.$store.state.session.module.id) {
                  find = true
                  break
                }
              }
              if (!find) {
                this.$store.dispatch('setSessionModule', {})
              }
            } else {
              this.$store.dispatch('setSessionModule', {})
            }
            this.menus = menus
          })
        }
      })
    },
    updated () {
      this.$nextTick(function () {
        layout.setLayout()
      })
    },
    methods: {
      setModule (module) {
        this.$store.dispatch('setSessionModule', module)
        layout.setModule(this, module)
        this.loadData()
      },
      setMenu (menu) {
        layout.setMenu(this, menu)
        if (config.layout !== 1 && menu.pid === '-1') {
          this.loadData()
        }
      },
      loadData () {
        // 组装菜单树
        let ms = JSON.parse(JSON.stringify(this.menus))
        let nodes = []
        nodes.push({id: '-1', name: '功能菜单', icon: 'el-icon-menu', children: []})
        for (let menu of ms) {
          if (config.layout !== 1 && menu.pid === '-1') {
            nodes[0].children.push(menu)
            rescureMenu(nodes[0].children[nodes[0].children.length - 1], ms)
          } else {
            if (menu.pid === this.$store.state.session.module.id) {
              nodes[0].children.push(menu)
              rescureMenu(nodes[0].children[nodes[0].children.length - 1], ms)
            }
          }
        }
        function rescureMenu (node, ms) {
          if (node === null) {
            return
          }
          // 获取子节点
          for (let menu of ms) {
            if (menu.pid === node.id) {
              if (!node.children) {
                node.children = []
              }
              node.children.push(menu)
              rescureMenu(node.children[node.children.length - 1], ms)
            }
          }
        }
        this.data = nodes
      },
      clickNode (data) { // data: 节点数据
        if (data == null || data.id === '-1') {
          return
        }
        // 高亮当前节点
        this.$refs.tree.setCurrentKey(data.id)
        this.setMenu(data)
      }
    }
  }
</script>
